import { Fragment, type JSX } from "react";
import { Link, useMatches } from "react-router";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../ui/breadcrumb.js";

import { getBreadcrumbItems } from "./AppBreadcrumbs.helpers.js";

export function AppBreadcrumbs(): JSX.Element | null {
  const matches = useMatches();
  const items = getBreadcrumbItems(matches);

  if (items.length === 0) return null;

  return (
    <div className="overflow-x-auto border-b border-border/70 bg-background px-4 py-2 sm:px-6">
      <Breadcrumb>
        <BreadcrumbList className="flex-nowrap whitespace-nowrap text-xs">
          {items.map((item, index) => (
            <Fragment key={`${item.label}-${index}`}>
              {index > 0 ? <BreadcrumbSeparator /> : null}
              <BreadcrumbItem>
                {item.current || !item.to ? (
                  <BreadcrumbPage>{item.label}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={item.to}>{item.label}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
}
